"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._memoRemoteByInstanceId = _memoRemoteByInstanceId;
exports._memoRemoteByTarget = _memoRemoteByTarget;
exports._disconnectClient = _disconnectClient;
exports.safeSerialize = safeSerialize;
exports.entries = void 0;

require("regenerator-runtime/runtime");

var _isPlainObject = _interopRequireDefault(require("lodash/isPlainObject"));

var _find = _interopRequireDefault(require("lodash/find"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _memoRemoteByInstanceId(memo, instanceId) {
  var proxy = (0, _find.default)(this.remotes, function (x) {
    return x.instanceId === instanceId;
  });

  if (proxy) {
    memo.push(proxy);
  }

  return memo;
}

function _memoRemoteByTarget(memo, tgt) {
  var proxy = (0, _find.default)(this.remotes, function (x) {
    return x.target === tgt;
  });

  if (proxy) {
    memo.push(proxy);
  }

  return memo;
}

function _disconnectClient(client) {
  client.disconnect();
}

function safeSerialize(envelope) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = entries(envelope)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          val = _step$value[1];

      if (typeof val === "function") {
        delete envelope[key];
      }

      if ((0, _isPlainObject.default)(val)) {
        safeSerialize(val);
      }

      if (Array.isArray(val)) {
        val.forEach(safeSerialize);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return envelope;
}

var entries =
/*#__PURE__*/
regeneratorRuntime.mark(function entries(obj) {
  var _i2, _Object$keys, k;

  return regeneratorRuntime.wrap(function entries$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (["object", "function"].indexOf(_typeof(obj)) === -1) {
            obj = {};
          }

          _i2 = 0, _Object$keys = Object.keys(obj);

        case 2:
          if (!(_i2 < _Object$keys.length)) {
            _context.next = 9;
            break;
          }

          k = _Object$keys[_i2];
          _context.next = 6;
          return [k, obj[k]];

        case 6:
          _i2++;
          _context.next = 2;
          break;

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, entries);
});
exports.entries = entries;